import { createContext } from "react";

/** Provides the PanelContainer DOM element so SlottedWindow can portal its FAB inside the panel. */
export const SidePanelFabTargetContext = createContext<HTMLDivElement | null>(null);
